import * as licenseService from './service';
import * as actionTypes from './actionTypes';

const log = require("loglevel").getLogger("licenseActions");
log.setLevel("debug");

/**
 * Loads license information from the backend API
 * 
 * @returns {Function} Redux thunk action
 */
export const loadLicenseInfo = () => {
	return async (dispatch) => {
		log.debug("LicenseActions -> loadLicenseInfo -> Enter");

		dispatch({ type: actionTypes.LICENSE_LOADING });

		const result = await licenseService.getLicenseInfo();

		if (result && result.status === 'ok') {
			// If we have actual license data, use it
			if (result.data) {
				await dispatch({
					type: actionTypes.LICENSE_LOADED,
					data: result.data,
				});
			} else {
				// If status is ok but no data, create default license info with pending status
				await dispatch({
					type: actionTypes.LICENSE_LOADED,
					data: {
						client_id: null,
						pricing_tier_name: null,
						pricing_tier_duration: null,
						status: 'pending',
						purchase_date: null,
						expiration_date: null,
						connector_version: null
					},
				});
			}
		} else {
			await dispatch({
				type: actionTypes.LICENSE_ERROR,
				error: 'Failed to load license information'
			});
		}
	};
};

export const loadPricingTiers = () => {
	return async (dispatch) => {
		dispatch({ type: actionTypes.LOAD_PRICING_TIERS });
		
		try {
			const response = await licenseService.getPricingTiers();
			
			if (response && response.status === 'ok') {
				dispatch({
					type: actionTypes.LOAD_PRICING_TIERS_SUCCESS,
					payload: response.data
				});
				return response;
			} else {
				dispatch({
					type: actionTypes.LOAD_PRICING_TIERS_FAILURE,
					payload: 'Failed to load pricing tiers'
				});
				return { status: 'error', message: 'Failed to load pricing tiers' };
			}
		} catch (error) {
			dispatch({
				type: actionTypes.LOAD_PRICING_TIERS_FAILURE,
				payload: error.message || 'Failed to load pricing tiers'
			});
			return { status: 'error', message: error.message || 'Failed to load pricing tiers' };
		}
	};
}; 

// Action types are now imported from actionTypes.js

export const loadLicenses = (page = 1, limit = 10) => {
	return async (dispatch) => {
		dispatch({ type: actionTypes.LOAD_LICENSES });
		
		try {
			const response = await licenseService.getLicenses(page, limit);
			
			if (response && response.status === 'ok') {
				dispatch({
					type: actionTypes.LOAD_LICENSES_SUCCESS,
					payload: {
						licenses: response.data,
						metadata: response.metadata
					}
				});
			} else {
				dispatch({
					type: actionTypes.LOAD_LICENSES_FAILURE,
					payload: 'Failed to load licenses'
				});
			}
		} catch (error) {
			dispatch({
				type: actionTypes.LOAD_LICENSES_FAILURE,
				payload: error.message || 'Failed to load licenses'
			});
		}
	};
};

export const createLicense = (pricingTierId) => {
	return async (dispatch) => {
		dispatch({ type: actionTypes.CREATE_LICENSE });
		
		try {
			const response = await licenseService.createLicense(pricingTierId);
			
			if (response && response.status === 'ok') {
				dispatch({
					type: actionTypes.CREATE_LICENSE_SUCCESS,
					payload: response.data
				});
				return response;
			} else {
				dispatch({
					type: actionTypes.CREATE_LICENSE_FAILURE,
					payload: 'Failed to create license'
				});
				return { status: 'error', message: 'Failed to create license' };
			}
		} catch (error) {
			dispatch({
				type: actionTypes.CREATE_LICENSE_FAILURE,
				payload: error.message || 'Failed to create license'
			});
			return { status: 'error', message: error.message || 'Failed to create license' };
		}
	};
};

export const deleteLicense = (licenseId) => {
	return async (dispatch) => {
		dispatch({ type: actionTypes.DELETE_LICENSE });
		
		try {
			const response = await licenseService.deleteLicense(licenseId);
			
			if (response && response.status === 'ok') {
				dispatch({
					type: actionTypes.DELETE_LICENSE_SUCCESS,
					payload: licenseId
				});
				return response;
			} else {
				dispatch({
					type: actionTypes.DELETE_LICENSE_FAILURE,
					payload: 'Failed to delete license'
				});
				return { status: 'error', message: 'Failed to delete license' };
			}
		} catch (error) {
			dispatch({
				type: actionTypes.DELETE_LICENSE_FAILURE,
				payload: error.message || 'Failed to delete license'
			});
			return { status: 'error', message: error.message || 'Failed to delete license' };
		}
	};
}; 